class EflService extends EficienciaFiscalAbstractService

  configure: (configs, injector) ->
    configs.url = '/eficiencia-fiscal/efl'

    super(configs, injector)

  test: (data, callback) ->
    @save(data, callback)

angular.module('eficienciaFiscalModule').service('eflService', EflService)
